module.exports = __webpack_public_path__ + "static/img/zh_CN1.b5c904b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/zh_CN1.png
// module id = zeCk
// module chunks = 1